export default __webpack_public_path__ + "static/media/icon-exports.9e16a4f2.svg";